export default function Strengths() {
  const strengths = [
    {
      number: '01',
      title: '豊富な実績と専門知識',
      description: '業界トップクラスの取引実績を誇り、バケーションレンタル市場における深い知見と経験を有しております。市場動向を的確に捉え、最適なソリューションをご提案いたします。'
    },
    {
      number: '02',
      title: '全国ネットワーク',
      description: '主要都市から地方のリゾート地まで、全国に広がるネットワークを活用し、幅広い物件情報とサービスを提供。地域特性を理解した最適な提案が可能です。'
    },
    {
      number: '03',
      title: 'ワンストップサービス',
      description: '物件選定から契約、運用管理、収益最適化まで、すべてのプロセスを一貫してサポート。複数の業者とやり取りする手間を省き、効率的な事業運営を実現します。'
    },
    {
      number: '04',
      title: '充実したサポート体制',
      description: '専任担当者による丁寧なサポートと、24時間365日対応可能な体制を整備。緊急時の対応やゲスト対応など、安心してお任せいただけます。'
    }
  ];

  return (
    <section id="strengths" className="bg-[#FAF9F6] py-32">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-[40%_60%] gap-16">
          <div>
            <h2 className="font-serif text-[42px] text-black mb-10">選ばれる理由</h2>
            <p className="text-[16px] text-[#2C2C2C] leading-[1.9]">
              私たちは、お客様の大切な資産を最大限に活用するため、
              専門性の高いサービスと充実したサポート体制を提供しております。
              長年の実績と信頼に基づき、安心してお任せいただけます。
            </p>
          </div>

          <div className="space-y-12">
            {strengths.map((strength, index) => (
              <div key={index}>
                <div className="text-[14px] text-[#999999] mb-2 font-light">{strength.number}</div>
                <h3 className="text-[20px] font-bold text-black mb-4">{strength.title}</h3>
                <p className="text-[15px] text-[#666666] leading-[1.8]">{strength.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
